export const discord = 'https://discord.com/invite/8hVAKVAemq';
